import ConditionalRuleSet from "../../../common/models/conditionalRules/conditionalRuleSet";
import IRepo from "../../../common/interfaces/repo";
import Repo from "../../../common/state/modules/repo";
import {ConditionalFieldDefinition} from "../../../common/models/conditionalRules/conditionalFieldDefinition";
import ProcessFlowStepJumpTo from "~/models/processFlows/processFlowStepJumpTo";
import ProcessFlowStepElementConditionalRule from "~/models/processFlows/processFlowStepElementConditionalRule";
import ProcessFlowStepJumpToFactory from "~/models/processFlows/processFlowStepJumpToFactory";

export default class ProcessFlowStepElementConditionalRuleSet extends ConditionalRuleSet {
  static repo: IRepo<ProcessFlowStepElementConditionalRuleSet> = new Repo<ProcessFlowStepElementConditionalRuleSet>('conditionalRuleSets', ProcessFlowStepElementConditionalRuleSet);

  constructor(fieldName: string, definition: ConditionalFieldDefinition) {
    super(fieldName, definition);
    this.except.push('flow');
  }

  createNew(fieldName: string, conditionalFieldDefinition: ConditionalFieldDefinition): ProcessFlowStepElementConditionalRuleSet {
    return new ProcessFlowStepElementConditionalRuleSet(fieldName, conditionalFieldDefinition);
  }

  createNewRule(): ProcessFlowStepElementConditionalRule {
    return new ProcessFlowStepElementConditionalRule();
  }

  get jump_to(): ProcessFlowStepJumpTo {
    if (this.conditional_value instanceof ProcessFlowStepJumpTo) {
      return this.conditional_value;
    } else{
      return null;
    }
  }

  set jump_to(val: ProcessFlowStepJumpTo) {
    this.conditional_value = val;
  }

  get jump_to_client_id(): string {
    if (this.jump_to) {
      return this.jump_to.to_client_id;
    } else {
      return null;
    }
  }

  set jump_to_client_id(val: string) {
    if (this.parent instanceof ProcessFlowStepJumpTo) {
      if (!this.jump_to) {
        this.jump_to = ProcessFlowStepJumpToFactory.create(this);
      }
      this.jump_to.to_client_id = val;
    } else {
      console.error('Cannot assign jump_to_client_id when parent is not an process flow step');
    }
  }
}